export default __webpack_public_path__ + "static/media/crossButton.cdd53706.svg";